"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Asterisk = exports.InputWrapper = exports.ValidationPopUp = exports.CaptionMessage = exports.Label = void 0;
var _react = require("react");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledComponentsRtl = _interopRequireDefault(require("styled-components-rtl"));
var _polished = require("polished");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var Label = /*#__PURE__*/(0, _react.memo)(_styledComponents.default.label.withConfig({
  displayName: "FormFieldstyle__Label",
  componentId: "xzn1x4-0"
})(["display:block;margin-bottom:8px;", ";", ""], function (_ref) {
  var hideLabel = _ref.hideLabel;
  return hideLabel && _polished.hideVisually;
}, function (_ref2) {
  var light = _ref2.light,
    theme = _ref2.theme;
  return (0, _styledComponents.css)(["color:", ";"], light ? theme.formField.labelColorLight : theme.formField.labelColor);
}));
exports.Label = Label;
var CaptionMessage = _styledComponents.default.span.withConfig({
  displayName: "FormFieldstyle__CaptionMessage",
  componentId: "xzn1x4-1"
})(["padding:0 ", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.space.xxs;
});
exports.CaptionMessage = CaptionMessage;
var ValidationPopUp = _styledComponents.default.span.withConfig({
  displayName: "FormFieldstyle__ValidationPopUp",
  componentId: "xzn1x4-2"
})(["align-items:center;display:inline-flex;position:absolute;top:", ";z-index:3;", ";", " &:after{content:'';position:absolute;width:8px;height:8px;top:-4px;left:16px;transform:translateX(-50%) rotate(45deg);transform-origin:center;outline:none;pointer-events:none;z-index:-1;border-left:", ";border-top:", ";background:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return "calc(100% + ".concat(theme.space.xs, ")");
}, function (_ref5) {
  var formField = _ref5.theme.formField;
  return (0, _styledComponents.css)(["background-color:", ";border-radius:", ";border:", ";box-shadow:", ";color:", ";font-size:", " font-weight:", ";min-height:", ";padding:", ";"], formField.validationBackground, formField.validationBorderRadius, formField.validationBorder, formField.validationBoxShadow, formField.validationTextColor, formField.validationFontSize, formField.validationFontWeight, formField.validationTextColor, formField.validationPadding);
}, function (_ref6) {
  var validationMessageLeft = _ref6.validationMessageLeft;
  return validationMessageLeft ? (0, _styledComponents.css)(["left:0;"]) : (0, _styledComponents.css)(["right:0;"]);
}, function (_ref7) {
  var formField = _ref7.theme.formField;
  return formField.validationBorder;
}, function (_ref8) {
  var formField = _ref8.theme.formField;
  return formField.validationBorder;
}, function (_ref9) {
  var formField = _ref9.theme.formField;
  return formField.validationBackground;
});
exports.ValidationPopUp = ValidationPopUp;
var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "FormFieldstyle__InputWrapper",
  componentId: "xzn1x4-3"
})(["position:relative;"]);
exports.InputWrapper = InputWrapper;
var Asterisk = /*#__PURE__*/(0, _react.memo)(_styledComponents.default.span.withConfig({
  displayName: "FormFieldstyle__Asterisk",
  componentId: "xzn1x4-4"
})(["speak:none;", " position:absolute;", ""], (0, _styledComponentsRtl.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-left: ", ";\n  "])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.space.xxs;
}), function (_ref11) {
  var light = _ref11.light,
    theme = _ref11.theme;
  return (0, _styledComponents.css)(["color:", ";"], light ? theme.formField.requiredAsteriskColorLight : theme.formField.requiredAsteriskColor);
}));
exports.Asterisk = Asterisk;
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "FormFieldstyle__Wrapper",
  componentId: "xzn1x4-5"
})(["position:relative;display:block;", ";"], function (_ref12) {
  var theme = _ref12.theme,
    disableMargin = _ref12.disableMargin,
    halfMargin = _ref12.halfMargin;
  return !disableMargin && (0, _styledComponents.css)(["margin-bottom:", ";padding-bottom:", ";"], halfMargin ? "".concat((0, _polished.stripUnit)(theme.formField.spacing) / 2, "px") : theme.formField.spacing, halfMargin ? "".concat((0, _polished.stripUnit)(theme.formField.spacing) / 2, "px") : theme.formField.spacing);
});
exports.Wrapper = Wrapper;